module.exports = __webpack_public_path__ + "img/MediamatikerIn_EFZ_SC_018.ba1adeb6.jpg";